var _desc, _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIco(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhoto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.80462876,3.09346622 C5.86606817,3.05195748 6.57695766,2.95023084 6.93729722,2.7882863 C7.24010269,2.65219884 7.50677855,2.42235689 7.7373248,2.09876045 L7.73732746,2.09876234 C8.6755308,0.781893136 10.1926237,2.3282309e-06 11.809525,2.3282309e-06 L12.0781541,2.3282309e-06 L12.0781541,4.63719953e-06 C13.7135363,4.63719953e-06 15.2455565,0.799762563 16.1804922,2.1415413 C16.5840957,2.72077535 17.0382053,3.01039237 17.542821,3.01039237 C18.0270876,3.01039237 18.5113541,3.01039237 18.9956207,3.01039237 L18.9956207,3.01039237 C21.7570444,3.01039237 23.9956207,5.24896862 23.9956207,8.01039237 C23.9956207,8.01664443 23.9956089,8.02289648 23.9955855,8.02914849 L23.958112,18.0187561 L23.958112,18.0187561 C23.9477807,20.7728386 21.712249,23 18.9581472,23 L5.0000097,23 L5.0000097,23 C2.23858595,23 9.69869462e-06,20.7614237 9.69869455e-06,18 L9.69869422e-06,8.08964394 L1.31419994e-05,8.08964394 C1.31419993e-05,5.40423727 2.12127312,3.19840174 4.80462876,3.09346622 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ice-breakers",
    transform: "translate(-61.000000, -925.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 911.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photo",
    transform: "translate(61.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    d: "M4.82416687,3.59308433 C2.40914736,3.68752628 0.500012798,5.67277788 0.500009699,8.08964394 L0.500009699,18 C0.500009699,20.4852814 2.51472832,22.5 5.0000097,22.5 L18.9581472,22.5 C21.4368388,22.5 23.4488174,20.4955547 23.4581155,18.0168805 L23.495589,8.02727288 C23.4956154,8.01883264 23.4956154,8.01883264 23.4956207,8.01039237 C23.4956207,5.525111 21.480902,3.51039237 18.9956207,3.51039237 L17.542821,3.51039237 C16.856118,3.51039237 16.2599539,3.13017742 15.7702582,2.42738754 C14.9288164,1.21978708 13.5499983,0.500004406 12.0781541,0.500002328 L11.809525,0.500002328 C10.3543145,0.500002328 8.98893033,1.20370356 8.14454482,2.38888431 C7.86469361,2.78168557 7.53015422,3.07001758 7.14226034,3.24434564 C6.70541756,3.44067241 5.947245,3.54916515 4.82416687,3.59308433 Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    stroke: "#666666",
    cx: 12,
    cy: 13.1428571,
    rx: 2.4,
    ry: 2.46428571
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    stroke: "#666666",
    cx: 12,
    cy: 13.1428571,
    rx: 4.8,
    ry: 4.92857143
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-7",
    stroke: "#666666",
    strokeWidth: 0.8,
    cx: 4,
    cy: 7,
    r: 1
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIco);
export default __webpack_public_path__ + "static/media/camera-ico.5d5cf9a6e0b3b426169c98aa0cc1fbe0.svg";
export { ForwardRef as ReactComponent };